import { useDispatch } from "react-redux";
import { debounce } from "../../../utils/hooks/useDebounce";
import {
  getPhotoSectionList,
  updateConfig,
} from "../../../store/slices/PhotoSection/PhotoSectionSlice";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
// import { startTimer } from "../api"; // Timer feature disabled
import { toast } from "react-toastify";

const usePhotoSection = () => {
  const dispatch = useDispatch();
  const [activeCard, setActiveCard] = useState({ id: "", key: "" });
  const [pendingPage, setPendingPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [clickedCardId, setClickedCardId] = useState(null);

  const photoSectionState = useSelector((state) => state.photoSection);
  const slug = sessionStorage?.getItem("slug");

  useEffect(() => {
    dispatch(
      updateConfig((state) => {
        state.cardData.Pending = [];
        state.search = "";
      }),
    );
    dispatch(
      getPhotoSectionList({
        page: 1,
        per_page: 10,
        process_slug: slug,
      }),
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [slug]);

  useEffect(() => {
    if (pendingPage !== 1) {
      if (
        photoSectionState.cardData.Pending?.length <=
        photoSectionState.total?.Pending
      ) {
        dispatch(
          getPhotoSectionList({
            page: pendingPage,
            per_page: 10,
            process_slug: slug,
            search: photoSectionState.search,
          }),
        );
      } else if (
        photoSectionState.cardData.Pending?.length >
        photoSectionState.total?.Pending
      ) {
        setIsLoading(false);
      }
    }
    // eslint-disable-next-line
  }, [pendingPage]);

  const handleSearchInput = (searchValue) => {
    dispatch(
      updateConfig((state) => (state.search = searchValue?.target?.value)),
    );
  };

  // Timer feature disabled
  // const startTimerPhoto = (item) => {
  //   setClickedCardId(item?._id);
  //   if (!item?._id || clickedCardId === item._id) {
  //     return;
  //   }
  //   let body = {
  //     receipt_id: item?._id,
  //     process_slug: slug,
  //   };
  //   startTimer(body).then((response) => {
  //     if (response?.data?.status_code === 200) {
  //       toast.success("Timer Started");
  //     } else {
  //       toast.error("Can't Start Timer");
  //     }
  //   });
  // };

  const handleCardClick = (e) => {
    setActiveCard({ id: e._id, key: "Pending" });
    // startTimerPhoto(e); // Timer feature disabled
    dispatch(
      updateConfig((state) => {
        state.showTable = true;
        state.selectedId = e?._id;
        state.gli_id = e?.gli_number;
        state.currentPage = 1;
        state.currentTablePage = 1;
        state.rawPhotoWorkCompleted = e?.raw_photo_completed;
      }),
    );
  };

  const handleLoadMore = (mouseHover) => {
    if (
      mouseHover === "Pending" &&
      photoSectionState?.cardData?.Pending?.length <=
        photoSectionState?.total?.Pending
    ) {
      setPendingPage(pendingPage + 1);
      dispatch(
        updateConfig((state) => {
          state.currentPage = pendingPage + 1;
        }),
      );
    }
  };

  const handleSearch = () => {
    const searchValue = photoSectionState?.search;
    setPendingPage(1);
    dispatch(
      updateConfig((state) => {
        state.cardData.Pending = [];
        state.currentPage = 1;
      }),
    );
    dispatch(
      getPhotoSectionList({
        search: searchValue,
        page: 1,
        process_slug: slug,
        per_page: 10,
      }),
    );
  };

  return {
    activeCard,
    isLoading,
    photoSectionState,
    cardData: photoSectionState?.cardData,
    totalLength: { Pending: photoSectionState.total.Pending },
    apiStatus: { Pending: photoSectionState?.pendingCardStatus },
    setIsLoading,
    handleSearchInput,
    handleSearch,
    handleCardClick,
    handleLoadMore,
  };
};

export default usePhotoSection;
